// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/asset-approvals/tabs/asset-approvals-provider/asset-approvals-provider.less
// module id = 3216
// module chunks = 0